import { Table as AntTable, Col, Flex, TableProps } from 'antd';

import React, { ReactNode, memo, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Button } from 'components/src';
import { useTranslation } from 'react-i18next';
import { IoFilter } from 'react-icons/io5';
import { BiHide } from 'react-icons/bi';

interface Props<T> extends TableProps<T> {
  columns?: any;
  dataSource?: any;
  loading?: boolean;
  pagination?: any;
  excelIcon?: ReactNode;
  filterComponent?: ReactNode;
}

const useStyle = createUseStyles({
  table: {
    userSelect: 'text',
  },
});

const Table = memo(function <T>({
  columns,
  dataSource,
  loading,
  pagination,
  excelIcon,
  filterComponent,
}: Props<T>) {
  const classes = useStyle();
  const { i18n } = useTranslation();
  const [showFilter, setShowFilter] = useState(false);

  const handleClick = () => {
    setShowFilter(!showFilter);
  };
  return (
    <>
      <Flex
        style={{ margin: 20 }}
        align="center"
        justify="space-between"
      >
        <Col xs={7} sm={8} md={4} lg={3} xl={2} xxl={1}>
          <Button
            style={{
              backgroundColor: 'gray',
            }}
            onClick={handleClick}
            title={i18n.t(showFilter ? 'hide' : 'advanceSearch')}
          >
            {showFilter ? <BiHide /> : <IoFilter />}
          </Button>
        </Col>
        <Col xs={2} sm={2} md={2} lg={2} xl={2} xxl={2}>
          {excelIcon}
        </Col>
      </Flex>
      {showFilter && filterComponent}
      <br />
      <AntTable
        className={classes.table}
        {...{ columns, dataSource, loading, pagination }}
        scroll={{ x: 'max-content' }}
      />
    </>
  );
});

export { Table };
